// extracted by mini-css-extract-plugin
export default {"waitResend":"SendCodeAgain_waitResend__SVViN","haveNotReceived":"SendCodeAgain_haveNotReceived__xnydv"};